import {
  addCustomMeasurementEndpoint,
  deleteCustomMeasurementEndpoint,
  updateCustomMeasurementEndpoint,
} from "./api/CustomMeasurement";

export const addCustomMeasurementToDatabase = async measurementData => {
  try {
    const response = await addCustomMeasurementEndpoint(measurementData);
    return response.data;
  } catch (error) {
    throw new Error(`Error adding custom measurement: ${error.message}`);
  }
};

export const deleteCustomMeasurementFromDatabase = async measurementId => {
  try {
    const response = await deleteCustomMeasurementEndpoint(measurementId);
    return response.data;
  } catch (error) {
    throw new Error(`Error deleting custom measurement: ${error.message}`);
  }
};

export const updateCustomMeasurementInDatabase = async (
  updatedMeasurementData,
  measurementId
) => {
  try {
    const response = await updateCustomMeasurementEndpoint(
      updatedMeasurementData,
      measurementId
    );
    return response;
  } catch (error) {
    throw new Error(`Error updating custom measurement: ${error.message}`);
  }
};
